import { UpdateCardModal } from '@/components/BillingPage/UpdateCardModal'
import { Glyph } from '@/components/svgs/Glyph'
import { colors } from '@/constants/colors'
import { HStack, VStack } from '@/ui/core/stack'
import { Text } from '@/ui/core/typography'
import { View } from 'react-native'

/** A payment did not go through. Coral, first thing on the page, with the fix beside it. */
export const AttentionNote = () => (
	<View className="rounded-note bg-accent px-4 py-4">
		<HStack className="items-center" gap={14}>
			<View className="h-10 w-10 items-center justify-center rounded-full bg-white">
				<Glyph name="asterisk" size={20} color={colors.accent} />
			</View>
			<VStack gap={2} className="flex-1">
				<Text size="body0" weight="bold" tone="white">
					A payment didn't go through
				</Text>
				<Text size="body1" tone="white" className="opacity-80">
					Check your card and we'll try again
				</Text>
			</VStack>
			<UpdateCardModal label="Fix" tone="white" />
		</HStack>
	</View>
)
